# GraphQL mutation to create a slack automation
#import "../fragments/sales-automation-stageset.graphql"

mutation CreateClosedLeadSlackMessage(
    $closedLeadSlackMessage: CreateClosedLeadSlackMessageInputFieldInput!
) {
    createClosedLeadSlackMessage(input: {closedLeadSlackMessage: $closedLeadSlackMessage}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
